import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { keywordGroupsTransforms } from "app/services/keyword-groups";
// eslint-disable-next-line max-len
import { SERPFeaturesCompositionKeywordsContainer } from "app/pages/keyword-research/website-analysis/pages/seo-overview/serp-opportunities/serp-features-composition/SERPFeaturesCompositionKeywordsContainer";
import type { Filter } from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import type { IWidgetSelectionsSubtitles } from "app/components/React/WidgetContainer/WidgetService";
import { WidgetService } from "app/components/React/WidgetContainer/WidgetService";
import CountryService from "app/services/CountryService";

import { DeviceDistribution } from "./device-distribution/DeviceDistribution";
import { Intent } from "./intent/Intent";
import { KeywordIdeas } from "./keyword-ideas/KeywordIdeas";
import { MetricsRow, MetricsSpace } from "./KeywordsOverviewPageStyledComponents";
import { SerpContainer } from "./serp/SerpContainer";
import { TopCompetitors } from "./top-competitors/TopCompetitors";
import { TrendOverTime } from "./trend-over-time/TrendOverTime";
import { VolumeAndClicks } from "./volume-and-clicks/VolumeAndClicks";

export const KeywordsOverviewPage: FC = () => {
    const { params } = useCurrentStateAndParams();
    const { duration, webSource, country, keyword } = params;
    const { id, text } = CountryService.getCountryById(country);
    const isKeywordGroup = keywordGroupsTransforms.isKeywordGroup(keyword);
    const selections: IWidgetSelectionsSubtitles = {
        duration,
        country: { id: String(id), text },
        webSource,
    };
    const subtitleFilters: Filter[] = WidgetService.getWidgetSubtitles(
        selections,
        false,
        null,
        false,
        true,
        null,
        true,
    ).filter(Boolean);

    return (
        <>
            <MetricsRow>
                <VolumeAndClicks />
                <MetricsSpace />
                <SerpContainer />
            </MetricsRow>
            <MetricsRow marginTop={"24px"}>
                <TrendOverTime subtitleFilters={subtitleFilters} />
            </MetricsRow>
            <MetricsRow marginTop={"24px"}>
                <TopCompetitors subtitleFilters={subtitleFilters} />
            </MetricsRow>
            {isKeywordGroup ? (
                <MetricsRow marginTop={"24px"}>
                    <SERPFeaturesCompositionKeywordsContainer />
                </MetricsRow>
            ) : null}
            <MetricsRow
                marginTop={"24px"}
                gap={"24px"}
            >
                <Intent subtitleFilters={subtitleFilters} />
                <DeviceDistribution subtitleFilters={subtitleFilters} />
            </MetricsRow>
            <MetricsRow marginTop={"24px"}>
                <KeywordIdeas subtitleFilters={subtitleFilters} />
            </MetricsRow>
        </>
    );
};
